import { LoaderCircle } from 'lucide-react';

import { Button as ShadcnButton } from '@/components/shadcn/ui/button';
import { cn } from '@/lib/cn';

type Props = React.ComponentProps<typeof ShadcnButton> & {
  isLoading?: boolean;
};

// shadcn Button을 감싸고, isLoading 상태에 slide transition을 적용하는 버튼
export default function Button({
  isLoading = false,
  children,
  className,
  disabled,
  ...props
}: Props) {
  return (
    <ShadcnButton
      className={cn(
        'relative overflow-hidden not-disabled:cursor-pointer',
        isLoading && 'cursor-progress',
        className,
      )}
      disabled={disabled || isLoading}
      {...props}
    >
      {/* 로딩 스피너: 아래에서 슬라이드 인 */}
      <span
        aria-hidden={!isLoading}
        className={cn(
          'absolute inset-0 flex items-center justify-center transition-transform duration-200',
          isLoading ? 'translate-y-0' : 'translate-y-[150%]',
        )}
      >
        <LoaderCircle className="size-4 animate-spin" />
      </span>

      {/* 콘텐츠: 위로 슬라이드 아웃 */}
      <span
        className={cn(
          'flex items-center justify-center gap-2 transition-transform duration-200',
          isLoading && '-translate-y-[150%]',
        )}
      >
        {children}
      </span>
    </ShadcnButton>
  );
}
